import { media } from '@belong/themes';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -4rem;

  ${media('md')`
    flex-direction: row;
    flex-wrap: wrap;
  `}
`;

export const Item = styled.div`
  text-align: center;
  margin-top: 4rem;

  img {
    display: block;
    max-width: 16.9rem;
    max-height: 3.2rem;
  }

  ${media('md')`
    img {
        margin: 0 2.4rem;
    }
  `}
`;
